import { FC } from "react"
import Spinner from 'react-bootstrap/Spinner';
import pageLoaderCss from './pageLoader.module.css';
import logo from '../../assets/images/new-Ma-logo.svg';

/*
  * Enhanced Page Loader Component with EE Logo
*/
const PageLoader:FC = () => {
  return (
    <div className={pageLoaderCss.loader_container}>
      <div className={pageLoaderCss.loader_content}>
        <div className={pageLoaderCss.logo_container}>
          <img src={logo} alt="Employee Engagement" className={pageLoaderCss.logo} />
        </div>
        <div className={pageLoaderCss.loading_text}>
          Please wait while we setup the app ...
        </div>
        <div className={pageLoaderCss.spinner_container}>
          <Spinner animation="border" variant="primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      </div>
    </div>
  )
}

export default PageLoader